import styled, { css } from 'styled-components/macro';
import colors from 'styles/themes/colors';
import { ReactComponent as AllDspIcon } from 'icons/allDspIcon.svg';
import { ThemeProps } from 'types/styled';
import Span from 'components/elements/span';
import Box from 'components/elements/Box';
import { MenuRoot } from 'components/base/Menu';

export const AllDSPIcon = styled(AllDspIcon)`
  margin-right: 0.5rem;
`;

export const LabelSpan = styled(Span)`
  width: 90px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const ButtonBox = styled(Box)<ThemeProps<'div'>>`
  padding-left: 0.75rem;
  color: ${colors.NightBlue};

  ${({ isGreen }): any =>
    isGreen &&
    css`
      background: ${colors.AccentGreen};

      padding: ${({ theme }): string =>
        `0.7rem ${theme.spacing.medium} 0.7rem 0.75rem `};

      span {
        color: white;
      }
    `}
`;

export const StyledDropdown = styled('div')`
  border-left: 1px solid #d9d9d9;
  margin-left: 0.5rem;
  width: 140px;
  @media screen and (max-width: 30em) {
    width: 120px;
  }

  span {
    height: auto;
    width: auto;
    position: relative;
  }

  figure {
    margin-left: -127px;
    width: 268px;
    top: 40px;
    max-height: 460px;
    overflow-y: auto;
  }

  @media screen and (max-width: 40em) {
    ${MenuRoot} {
      position: static;
    }

    figure {
      width: 106%;
      left: -3%;
      margin-left: 0;
      top: 47px;
    }
  }
`;

export const ListItemBox = styled(Box)`
  &:hover,
  &[aria-selected='true'] {
    background: ${colors.Sand};
  }

  padding: 10px;

  span {
    color: ${colors.DeepBlue};
    line-height: 26px;
  }
`;
